import React from 'react'
import { Text, DropButton, Box } from 'grommet'
import loadable from '@loadable/component'
import { LatestData } from '../../../Data/UpdateData'
import TipDrop from '../../Button/TipDrop'
import { daysBetween } from '../../../utils'

const Content = loadable(() => import('./Content'))

const Versioning = ({ size }) => {
  const { item, version } = LatestData
  let formattedDate = ''
  const updateDate = new Date(item.date)
  const todayDate = new Date()
  const daysDifference = daysBetween(updateDate, todayDate)

  if (daysDifference <= 45) {
    //45 days
    formattedDate = updateDate.toDateString().split(' ').slice(1, 3).join(' ')
  }
  return (
    <Box background="toolTranslucentBg">
      <TipDrop position="top" content="See What's New">
        <DropButton
          alignSelf="center"
          margin={{ vertical: '.7rem' }}
          dropContent={
            <Content
              item={item}
              size={size}
              version={version}
              fallback={
                <Box
                  width="60rem"
                  height="20em"
                  round="2rem"
                  margin="xsmall"
                  border={{
                    color: 'tooltipBg',
                    size: '.3rem',
                    style: 'solid',
                    side: 'all',
                  }}
                  align="center"
                  justify="center"
                  background="baseBackground"
                >
                  Loading...
                </Box>
              }
            />
          }
          dropAlign={{ top: 'bottom' }}
          dropProps={{ background: 'transparent', plain: true, stretch: false }}
        >
          <Text
            alignSelf="center"
            size="1.6rem"
            // color="blackText"
            //   color="inactiveText"
            weight={400}
          >
            <u>
              Version {version} {formattedDate && `(${formattedDate})`}
            </u>
          </Text>
        </DropButton>
      </TipDrop>
    </Box>
  )
}

export default Versioning
